class Menu {
    groups: MenuGroup[];

    public static getMainMenu(): Menu {
        let overviewGroup = {
            name: '系统概览',
            items: [
                {
                    name: '系统总览',
                    path: '/dashboard',
                },
            ],
        };

        let tenantGroup = {
            name: '租户管理',
            items: [
                {
                    name: '租户列表',
                    path: '/tenant-management',
                },
            ],
        };

        let deviceGroup = {
            name: '设备分配',
            items: [
                {
                    name: '设备绑定',
                    path: '/tenant-device',
                },
            ],
        };

        let systemSettingsGroup = {
            name: '系统设置',
            items: [
                {
                    name: '用户管理',
                    path: '/user-management'
                },
            ],
        };

        return {
            groups: [
                overviewGroup,
                tenantGroup,
                deviceGroup,
                systemSettingsGroup,
            ],
        }
    }
}

class MenuGroup {
    name: string;
    items: MenuItem[];
}

class MenuItem {
    name: string;
    path: string;
}

export default Menu;
export { Menu, MenuGroup, MenuItem};
